import { ExpressionType, type IExpression } from '../IExpression.ts';
import { type IReference } from '../references/IReference.ts';
import { type IReferenceExpression } from '../repository/reference/IReferenceExpression.ts';
import {
  isObjectsArrayField,
  type ObjectsArrayFieldDatatype,
} from './Datatype.ts';

export interface IReferenceExpressionObjectsArray extends IReferenceExpression {
  value: IReference & {
    field: ObjectsArrayFieldDatatype;
  };
}

export function isExpressionReferenceOfObjectsArray(
  expression: IExpression | null | undefined,
): expression is IReferenceExpressionObjectsArray {
  return (
    expression != null &&
    expression.type === ExpressionType.Reference &&
    expression.value?.field != null &&
    isObjectsArrayField(expression.value.field)
  );
}
